<template>
    <div
        class="font-bold flex justify-start items-center">
        <span
            class="w-3 h-3 max-h-3 max-w-3 min-w-3 rounded-full mr-2 p-0 m-0"
            :class="getObjectStatus.classDot"/>

        <span
            v-if="getObjectStatus.label"
            :class="getObjectStatus.classText"
            class="font-medium mr-2 text-main-text  select-none p-0 m-0">
            {{ getObjectStatus.label || '' }}
        </span>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object,
  module: {
    type: String
  },
  status: {
    type: [String, Number]
  },
  size: {
    type: String,
    default: 'default'
  },
  keyStatus: {
    type: String
  }
})

const { params, module, status, size, keyStatus } = toRefs(props)

const CModule = computed(() => {
  return params?.value?.module || module?.value
})

const CKeyStatus = computed(() => {
  return params?.value?.keyStatus || keyStatus?.value
})

const CStatus = computed(() => {
  if (params?.value && CKeyStatus.value) {
    return params?.value?.data?.[CKeyStatus.value]
  }
  return params?.value?.data?.status || status?.value
})

const CSize = computed(() => {
  return params?.value?.size || size?.value
})

const getStatusModule: { [key: string]: any } = {
  vehicle: {
    1: { label: $t('labels.readyShip'), classDot: 'bg-success-500' },
    '-1': { label: $t('labels.vehicleModule.notReady'), classDot: 'bg-error-500' }
  },
  driver: {
    0: { label: $t('labels.notReadyYet'), classDot: 'bg-error-500' },
    1: { label: $t('labels.conditionallyReady'), classDot: 'bg-warning-500' },
    2: { label: $t('labels.ready'), classDot: 'bg-success-500' }
  }

}

const getObjectStatus = computed(() => {
  const classT = getStatusModule[CModule.value][String(CStatus.value)] || {}

  return classT
})
</script>

<style scoped></style>
